function offreSponsoTemplate(id) {
  const target = document.getElementById(id);
  target.innerHTML = `
    <div class="offre-sponso">
        <h2 class="js-native-ad-title"></h2>
        <div class="content-entreprise">
            <div class="logo-entreprise">
                <img class="js-native-ad-image" src="">
            </div>
            <div class="infos-entreprise">
                <div class="nom-entreprise js-native-ad-company"></div>
            </div>
        </div>
        <p class="js-native-ad-body"></p>
        <div class="footer-offre">
            <span class="cta"><span class="js-native-ad-cta"></span><span class="icon-arrow-top rotate-icon"></span></span>
            <span class="annonce-sponso">Annonce sponsoris&eacute;e</span>
        </div>
    </div>`;
}

const offreSponsoId = 'offreSponso';

export { offreSponsoTemplate, offreSponsoId };
